import { IAppTheme } from "@cayo/shared/themes/types";
import { ThemePreviewColors } from "../types";

interface INavBarStyles {
  "hover-item-background"?: string;
  background?: string;
}

interface IHeaderStyles {
  background?: string;
}

interface IThemeStyles {
  navBar?: INavBarStyles;
  navHeader?: IHeaderStyles;
}

export const getThemePreviewColors = (theme?: IAppTheme): ThemePreviewColors => {
  if (!theme) {
    return [null, null, null];
  }

  const brandColors = theme.cayoTheme.brandColors;
  const elementStyles = theme.elementStyles as unknown as IThemeStyles;
  const officePalette = theme.officeTheme.palette;

  const headerColor = elementStyles.navHeader?.background ?? officePalette.themePrimary ?? null;
  const navBarHoverColor =
    elementStyles.navBar?.["hover-item-background"] ?? brandColors.secondaryBackground ?? null;
  const contentAreaColor = brandColors.primaryBackground ?? null;

  return [headerColor, navBarHoverColor, contentAreaColor];
};
